/**
 * compareFormDeriveText
 *
 * The one string comparator of the derive engine: plain code-unit ordering,
 * shared by `computeFormDerives` (rowIds, operand paths), `detectFormDeriveCycle`
 * (graph node keys) and `resolveFormDeriveInputs` (stamp inputs). It is NEVER
 * `localeCompare`, whose order depends on the ambient locale — the client and the
 * server would then disagree about upsert order, `inputs` order and the material
 * line order the persisted hash is built from. Internal to this directory
 * (precedent: `isRecordValue`); the barrel exports the functions built on it.
 */

function compareFormDeriveText(a: string, b: string): number {
  return a < b ? -1 : a > b ? 1 : 0;
}

export { compareFormDeriveText };
